'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _pack = require('redux/modules/pack');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getExtension(mimeType) {
  var types = {
    'image/jpeg': 'JPG',
    'image/png': 'PNG',
    'image/x-exr': 'EXR',
    'image/tif': "TIF",
    'application/x-obj': 'OBJ',
    'application/x-fbx': 'FBX'
  };

  return types[mimeType];
}

function getMimeType(ext) {
  var types = {
    'JPG': 'image/jpeg',
    'PNG': 'image/png',
    'EXR': 'image/x-exr',
    'OBJ': 'application/x-obj',
    'FBX': 'application/x-fbx'
  };

  return types[ext];
}

function getDownloadSize() {}

var PackDownloadPopup = function (_React$Component) {
  (0, _inherits3.default)(PackDownloadPopup, _React$Component);

  function PackDownloadPopup(props) {
    (0, _classCallCheck3.default)(this, PackDownloadPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PackDownloadPopup.__proto__ || (0, _getPrototypeOf2.default)(PackDownloadPopup)).call(this, props));

    _this.state = {
      resolution: '256x256',
      imageFormat: 'JPG',
      meshFormat: 'OBJ',
      extra: true
    };
    return _this;
  }

  (0, _createClass3.default)(PackDownloadPopup, [{
    key: 'getCurrentConfig',
    value: function getCurrentConfig() {
      return {
        config: {
          resolution: parseInt(this.state.resolution.toLowerCase().split('x')[0]),
          image_format: this.state.imageFormat.toLowerCase(),
          mesh_format: getMimeType(this.state.meshFormat),
          additional_files: this.state.extra
        }
      };
    }
  }, {
    key: 'onExtraClick',
    value: function onExtraClick(e) {
      var checked = !!e.target.checked;
      this.setState({ extra: checked });
    }
  }, {
    key: 'onResolutionChange',
    value: function onResolutionChange(e) {
      this.setState({ resolution: e.currentTarget.value });
    }
  }, {
    key: 'onImageFormatChange',
    value: function onImageFormatChange(e) {
      this.setState({ imageFormat: e.currentTarget.value });
    }
  }, {
    key: 'onMeshFormatChange',
    value: function onMeshFormatChange(e) {
      this.setState({ meshFormat: e.currentTarget.value });
    }
  }, {
    key: 'onDownloadClick',
    value: function onDownloadClick() {
      var config = this.getCurrentConfig();
      this.props.dispatch((0, _pack.downloadPack)(this.props.packData._id, config));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          resolution = _state.resolution,
          imageFormat = _state.imageFormat,
          meshFormat = _state.meshFormat,
          extra = _state.extra;

      var styles = require('./PackDownloadPopup.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.CustomiseDownload },
        _react2.default.createElement(
          'div',
          { className: styles['PackPopupSettings__field'] },
          _react2.default.createElement(
            'label',
            { htmlFor: '' },
            'Resolution:'
          ),
          _react2.default.createElement(
            _components.Select,
            {
              onChange: this.onResolutionChange.bind(this),
              className: styles['PackPopupSettings__field-select'],
              name: 'resolution',
              id: "pack-settings-resolution",
              value: resolution },
            this.props.packData.resolutions.map(function (resolution) {
              return _react2.default.createElement(
                'option',
                null,
                resolution + 'x' + resolution
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles['PackPopupSettings__field'] },
          _react2.default.createElement(
            'label',
            { htmlFor: '' },
            'Image Format:'
          ),
          _react2.default.createElement(
            _components.Select,
            {
              onChange: this.onImageFormatChange.bind(this),
              className: styles['PackPopupSettings__field-select'],
              name: 'image-format',
              id: "pack-settings-image-format",
              value: imageFormat },
            this.props.packData.imageFormats.map(function (image) {
              return _react2.default.createElement(
                'option',
                null,
                image.toUpperCase()
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles['PackPopupSettings__field'] },
          _react2.default.createElement(
            'label',
            { htmlFor: '' },
            'Mesh Format:'
          ),
          _react2.default.createElement(
            _components.Select,
            {
              onChange: this.onMeshFormatChange.bind(this),
              className: styles['PackPopupSettings__field-select'],
              name: 'mesh-format',
              id: "pack-settings-mesh-format",
              value: meshFormat },
            this.props.packData.meshFormats.map(function (mesh) {
              return _react2.default.createElement(
                'option',
                null,
                getExtension(mesh)
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { margin: '1.5em 0' } },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_components.Checkbox, {
              checked: extra,
              onChange: this.onExtraClick.bind(this),
              name: 'extra',
              id: "pack-settings-extra",
              className: styles['PackPopupSettings__field-checkbox'] }),
            'Extra Content'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { margin: '1.5em 0' } },
          _react2.default.createElement(
            'p',
            null,
            'Includes:',
            _react2.default.createElement('br', null),
            'ZTool, High Poly Meshes & Brushes'
          )
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(_components.Button, { fullWidth: true, primary: true, label: 'Download Now', onClick: this.onDownloadClick.bind(this) })
      );
    }
  }]);
  return PackDownloadPopup;
}(_react2.default.Component);

exports.default = PackDownloadPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PackDownloadPopup/PackDownloadPopup.jsx
// module id = 2700
// module chunks = 0